import React from 'react';
import { FaLinkedin, FaGithub, FaDiscord } from 'react-icons/fa6';
import '../../css/common/social-hex-style.css';

function SocialMediaHexes() {
  return (
    <div className="social-hex-links">
      <a
        href="https://github.com/dave-sommerville"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="social-hex">
          <FaGithub className="social-hex-icon"/>
        </div>
      </a>
      <a
        href="https://www.linkedin.com/in/dave-sommerville/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="mid social-hex">
          <FaLinkedin className="social-hex-icon"/>
        </div>
      </a>
      <a
        href="https://discord.com/users/ds_code"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="social-hex">
          <FaDiscord className="social-hex-icon"/>
        </div>
      </a>

    </div>
  );
}
export default SocialMediaHexes;
